export const LANGUAGES = ['en', 'es', 'fr', 'de', 'it', 'da'] as const;
export type Language = (typeof LANGUAGES)[number];

export interface LanguageConfig {
  code: Language;
  label: string;
  short: string;
  flag: string;
  locale: string;
}

export const SUPPORTED_LANGUAGES: LanguageConfig[] = [
  { code: 'es', label: 'Español', short: 'ES', flag: '/flags/es.svg', locale: 'es-ES' },
  { code: 'en', label: 'English', short: 'EN', flag: '/flags/gb.svg', locale: 'en-GB' },
  { code: 'fr', label: 'Français', short: 'FR', flag: '/flags/fr.svg', locale: 'fr-FR' },
  { code: 'de', label: 'Deutsch', short: 'DE', flag: '/flags/de.svg', locale: 'de-DE' },
  { code: 'it', label: 'Italiano', short: 'IT', flag: '/flags/it.svg', locale: 'it-IT' },
  { code: 'da', label: 'Dansk', short: 'DA', flag: '/flags/dk.svg', locale: 'da-DK' },
];

const LANGUAGE_SET = new Set<string>(LANGUAGES);

export function isLanguage(code: string | null | undefined): code is Language {
  return !!code && LANGUAGE_SET.has(code);
}

export function localeForLanguage(lang: Language): string {
  return SUPPORTED_LANGUAGES.find((l) => l.code === lang)?.locale ?? 'en-GB';
}

export function languageLabel(code: string): string {
  const found = SUPPORTED_LANGUAGES.find((l) => l.code === code);
  if (found) return found.label;
  const analyticsLabels: Record<string, string> = {
    es: 'Español',
    en: 'Inglés',
    fr: 'Francés',
    de: 'Alemán',
    it: 'Italiano',
    da: 'Danés',
  };
  return analyticsLabels[code] ?? code;
}

/** Promos solo tienen assets es/en; el resto usa inglés. */
export function promosLangForLanguage(lang: Language): 'es' | 'en' {
  return lang === 'es' ? 'es' : 'en';
}
